<template>
  <div>
    <search-filter></search-filter>
    <search-results></search-results>
  </div>
</template>

<script>
import SearchFilter from "./SearchFilter.vue";
import SearchResults from "./SearchResults.vue";

export default {
  data() {
    return {};
  },
  components: {
    SearchResults,
    SearchFilter,
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss"></style>
